// extracted by mini-css-extract-plugin
export default {"root":"DBdn3N","header":"yPtJTH","main":"R1_RCU"};